import {Component, OnInit} from '@angular/core';
import {
  Bank,
  CRM,
  CRMTypeId,
  FormatRule,
  Gateway,
  GatewayAdditionalOptionLabels,
  GatewayAdditionalOptions,
  GatewayAdditionalOptionsList,
  GatewayStatus,
  GatewayStatusLabels,
  GatewayType,
  getGatewayStatus,
  Merchant,
  Pager,
  ProcessorConfig,
  ProcessorConfigRules,
  ProcessorConfigRuleSet,
  ProcessorIdField,
  ProcessorIdRules,
  ProfileTab,
  Timezones,
  ThreeDsVerificationStatus,
  ThreeDsNetworkRow,
  ProductChip,
  ChipTone,
  ThreeDsIdRule,
  MerchantProfileListItem,
  MerchantProfileStatus,
} from '../../../_models';
import {ActivatedRoute, Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {CrudSaveComponent} from '../../../_directives';
import {Location} from '@angular/common';
import {HttpErrorResponse} from '@angular/common/http';
import {
  AlertService,
  CampaignService,
  CheckoutBankService,
  CheckoutGatewayService,
  CRMService,
  MerchantProfileService,
  MerchantService,
} from '../../../_services';
import {FormBuilder, Validators} from '@angular/forms';
import {forkJoin, Observable} from 'rxjs';
import {config} from '../../../../config/config';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {copyToClipboard, CustomValidators} from '../../../_helpers';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'checkout-gateway-new',
  templateUrl: './checkout-gateway-edit.component.html',
  styleUrls: ['./checkout-gateway-edit.component.scss', '../profiles-styles.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('500ms ease-in', style({ opacity: 1 }))]),
    ]),
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0px',
          opacity: 0,
          display: 'none',
        })
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
          marginTop: '20px',
        })
      ),
      transition('collapsed <=> expanded', animate('300ms ease-in-out')),
    ]),
  ],
})
export class CheckoutGatewayNewComponent extends CrudSaveComponent implements OnInit {
  ProfileTabs = ProfileTab;
  activeTab = ProfileTab.Credentials;
  gatewayStatus = GatewayStatus;
  banks: Bank[];
  merchantProfiles: MerchantProfileListItem[] = [];
  additional_options: GatewayAdditionalOptions[] = GatewayAdditionalOptionsList;
  selected_options: GatewayAdditionalOptions[] = [];
  gateway: Gateway;
  isPDFLoading: boolean = false;
  gatewayType = GatewayType;
  processorTypes: ProcessorConfig[];
  selectedProcessorType: ProcessorConfig;
  timezones = Timezones;
  chipTone = ChipTone;
  threeDsIdRule = ThreeDsIdRule;
  processorIdField = ProcessorIdField;
  noProcessorConfigRules: ProcessorConfigRuleSet = {};
  copiedValue: string | null = null;
  availableMerchants: { id: string | number; text: string }[] = [];
  merchantSettings = {
    enableCheckAll: false,
  };
  threeDsNetworks: ThreeDsNetworkRow[] = [
    this.buildNetworkRow('visa', 'Visa Secure', '/assets/audienceAssets/visa.png'),
    this.buildNetworkRow('mastercard', 'MasterCard', '/assets/audienceAssets/master.png'),
    this.buildNetworkRow('amex', 'American Express', '/assets/audienceAssets/amex.png'),
    this.buildNetworkRow('discover', 'Discover', '/assets/audienceAssets/discover.png'),
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected gatewayService: CheckoutGatewayService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected bankService: CheckoutBankService,
    protected crmService: CRMService,
    protected merchantService: MerchantService,
    protected merchantProfileService: MerchantProfileService,
    protected campaignService: CampaignService
  ) {
    super(router, location, route, gatewayService, alertService);
    this.isNew = true;
    this.objectName = 'gateway';
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [null, [Validators.required]],
      merchant_profile: [null, [Validators.required]],
      bank: [null],
      processor_type: [null, [Validators.required]],
      processor_config: this.formBuilder.group({}),
      descriptor: [null],
      merchant_id: [null],
      api_key: [null],
      public_key: [null],
      organization_id: [null],
      currency: ['usd', [Validators.required]],
      terminal_number: [null],
      acquirer_bin: [null, [Validators.minLength(6), Validators.maxLength(8)]],
      timezone: [null, [Validators.required]],
      monthly_cap: [null],
      type: [GatewayType.CyberSource, [Validators.required]],
      level3_data_enabled: [false, [Validators.required]],
      selected_crm_merchants: [null],
      three_ds_enabled: [false],
      visa_3ds_enabled: [false],
      visa_3ds_acquirer_id: [null],
      visa_3ds_merchant_id: [null],
      visa_3ds_verification_status: [ThreeDsVerificationStatus.Pending],
      mastercard_3ds_enabled: [false],
      mastercard_3ds_acquirer_id: [null],
      mastercard_3ds_merchant_id: [null],
      mastercard_3ds_verification_status: [ThreeDsVerificationStatus.Pending],
      amex_3ds_enabled: [false],
      amex_3ds_acquirer_id: [null],
      amex_3ds_merchant_id: [null],
      amex_3ds_verification_status: [ThreeDsVerificationStatus.Pending],
      discover_3ds_enabled: [false],
      discover_3ds_acquirer_id: [null],
      discover_3ds_merchant_id: [null],
      discover_3ds_verification_status: [ThreeDsVerificationStatus.Pending],
    });
    super.ngOnInit();

    this.gatewayService.getProcessorTypes().subscribe(
      (types: ProcessorConfig[]) => {
        this.processorTypes = types;
      },
      (error) => {
        this.handleError(error);
      }
    );

    this.merchantProfileService.list({ campaign: this.campaignService.getCurrentCampaignId() })
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (profiles: MerchantProfileListItem[]) => {
          this.merchantProfiles = profiles || [];
        },
        (error) => {
          this.handleError(error);
        }
      );

    this.bankService.list({ page: 1, page_size: config.maxPageSize })
      .subscribe(
      (data: Pager) => {
        if (data) {
          this.banks = data.results;

          if (!this.banks.length) {
            this.form.get('bank').disable();
          }
        }
      },
      (error) => {
        this.handleError(error);
      }
    );

    forkJoin([
      this.crmService.list({ page: 1, page_size: config.maxPageSize, 'type!': CRMTypeId.Test }),
      this.merchantService.list({ page: 1, page_size: config.maxPageSize, is_solvpath_gateway: true }),
    ]).subscribe(
      (data: [Pager, Pager]) => {
        if (data) {
          const crms = data[0].results;
          const merchants = data[1].results;
          const crmMap = {};
          const availableMerchants: { id: string | number; text: string }[] = [];

          crms.forEach((crm: CRM) => {
            crmMap[crm.id] = crm;
          });

          merchants.forEach((merchant: Merchant) => {
            const crm = crmMap[merchant.crm];
            availableMerchants.push({
              id: merchant.id,
              text: `${crm.name}: ${merchant.name} (${merchant.merchant_id})`,
            });
          });
          this.availableMerchants = availableMerchants;
          this.initSelectedMerchants();
        }
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  protected initSelectedMerchants() {
    if (
      this.gateway &&
      this.gateway.crm_merchants &&
      this.gateway.crm_merchants.length &&
      this.availableMerchants.length
    ) {
      const merchantMap = {};
      this.availableMerchants.forEach((merchant) => {
        merchantMap[merchant.id] = merchant;
      });

      const selectedMerchants = [];
      this.gateway.crm_merchants.forEach((merchantId) => {
        if (merchantMap[merchantId]) {
          selectedMerchants.push(merchantMap[merchantId]);
        }
      });

      this.form.patchValue({ selected_crm_merchants: selectedMerchants });
    }
  }

  selectProcessorType(event) {
    this.selectProcessorConfigType(event.target.value);
  }

  protected selectProcessorConfigType(type) {
    if (this.processorTypes) {
      const processorType = this.processorTypes.find((processorType) => processorType.id === Number(type));
      this.selectedProcessorType = processorType || null;
      this.updateProcessorIdValidators();
    } else {
      let _this = this;
      setTimeout(() => {
        _this.selectProcessorConfigType(type);
      }, 100);
    }
  }

  protected updateProcessorIdValidators() {
    this.applyIdValidators('merchant_id', ProcessorIdField.MerchantId);
    this.applyIdValidators('terminal_number', ProcessorIdField.TerminalNumber);
  }

  protected applyIdValidators(fieldName: string, field: ProcessorIdField) {
    const rule = this.getProcessorIdRule(field);

    this.setRequired(fieldName, !!rule, rule ? CustomValidators.formatRule(rule) : []);
  }

  protected getProcessorIdRule(field: ProcessorIdField): FormatRule {
    let rule: FormatRule = null;

    if (this.selectedProcessorType && ProcessorIdRules[Number(this.selectedProcessorType.id)]) {
      const rules = ProcessorIdRules[Number(this.selectedProcessorType.id)];

      rule = rules[field] ? rules[field] : null;
    }

    return rule;
  }

  isProcessorIdRequired(field: ProcessorIdField): boolean {
    return !!this.getProcessorIdRule(field);
  }

  getProcessorIdError(fieldName: string, field: ProcessorIdField, label: string): string {
    const rule = this.getProcessorIdRule(field);
    const prefix = rule ? this.selectedProcessorType.name + ' ' : '';

    return this.getFormatError(fieldName, label, rule, prefix);
  }

  getProcessorConfigRules(): ProcessorConfigRuleSet {
    let rules = this.noProcessorConfigRules;

    if (this.selectedProcessorType && ProcessorConfigRules[Number(this.selectedProcessorType.id)]) {
      rules = ProcessorConfigRules[Number(this.selectedProcessorType.id)];
    }

    return rules;
  }

  protected updateConditionalValidators() {
    this.threeDsNetworks.forEach((network) => {
      const networkOn = this.isNetworkEnabled(network);
      const idRules = networkOn ? CustomValidators.formatRule(ThreeDsIdRule) : [];
      this.setRequired(network.acquirerControl, networkOn, idRules);
      this.setRequired(network.merchantControl, networkOn, idRules);
    });
  }

  isMerchantProfileSelectable(profile: MerchantProfileListItem): boolean {
    return profile.status !== MerchantProfileStatus.Archived ||
      String(profile.id) === String(this.form.get('merchant_profile').value);
  }

  protected updateGateway(gateway: Gateway) {
    this.form.patchValue(gateway);
    this.selectProcessorConfigType(gateway.processor_type);
    this.selected_options = gateway.additional_options;
    this.gateway = gateway;
    this.initSelectedMerchants();
    this.updateConditionalValidators();

    const fields = { id: gateway.id };
    this.threeDsNetworks.forEach((network) => {
      fields[network.statusControl] = gateway[network.statusControl];
    });
    this.form.patchValue(fields, { emitEvent: false });
  }

  get isGatewayEnabled(): boolean {
    return this.gateway && this.gateway.is_enabled;
  }

  getGatewayChip(): ProductChip {
    let chip: ProductChip = { label: 'Not Configured', tone: ChipTone.None };

    if (this.gateway) {
      if (this.gateway.is_enabled && this.gateway.is_verified) {
        chip = { label: 'Verified', tone: ChipTone.Verified };
      } else if (this.gateway.is_enabled) {
        chip = { label: 'Pending Verification', tone: ChipTone.Pending };
      } else {
        chip = { label: 'Disabled', tone: ChipTone.Disabled };
      }
    }

    return chip;
  }

  onGatewayToggle(event: Event) {
    const input = event.target as HTMLInputElement;

    if (this.gateway) {
      const request: Observable<Gateway> = input.checked
        ? this.gatewayService.enable(this.gateway.id)
        : this.gatewayService.disable(this.gateway.id);

      this.loading = true;
      request.pipe(takeUntil(this._destroy$)).subscribe(
        (gateway: Gateway) => {
          this.alertService.success(input.checked ? 'Gateway enabled.' : 'Gateway disabled.');
          this.updateGateway(gateway);
          this.loading = false;
        },
        (error) => {
          input.checked = !input.checked;
          this.handleSubmitError(error, false, true);
          this.loading = false;
        }
      );
    }
  }

  canVerifyGateway(): boolean {
    return (
      this.gateway &&
      !this.gateway.is_verified &&
      !this.gateway.is_deleted &&
      !this.form.dirty
    );
  }

  getVerifyGatewayHint(): string {
    let hint = 'Run the verification transaction';

    if (!this.gateway) {
      hint = 'Save the gateway before verifying it';
    } else if (this.gateway.is_verified) {
      hint = 'This gateway is already verified';
    } else if (this.form.dirty) {
      hint = 'Save your changes before verifying';
    }

    return hint;
  }

  verifyGateway() {
    if (this.canVerifyGateway()) {
      this.loading = true;
      this.gatewayService
        .verify(this.gateway.id)
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          (gateway: Gateway) => {
            this.alertService.success('Gateway verified.');
            this.updateGateway(gateway);
            this.loading = false;
          },
          (error) => {
            this.handleSubmitError(error, false, true);
            this.loading = false;
          }
        );
    }
  }

  protected buildNetworkRow(key: string, label: string, icon: string): ThreeDsNetworkRow {
    return {
      key: key,
      label: label,
      icon: icon,
      enabledControl: key + '_3ds_enabled',
      acquirerControl: key + '_3ds_acquirer_id',
      merchantControl: key + '_3ds_merchant_id',
      statusControl: key + '_3ds_verification_status',
      editing: false,
    };
  }

  get isThreeDsEnabled() {
    return this.isBooleanFieldChecked('three_ds_enabled');
  }

  onThreeDsToggle(event: Event) {
    this.toggleBooleanField(event, 'three_ds_enabled');
    this.updateConditionalValidators();
  }

  onNetworkToggle(event: Event, network: ThreeDsNetworkRow) {
    this.toggleBooleanField(event, network.enabledControl);

    if (network.editing) {
      this.cancelNetworkEdit(network);
    }

    this.updateConditionalValidators();
  }

  isNetworkEnabled(network: ThreeDsNetworkRow): boolean {
    return this.isThreeDsEnabled && this.isBooleanFieldChecked(network.enabledControl);
  }

  // Verify sends the stored ids, so a network whose ids were edited, or a gateway not saved yet, can't be
  // verified until saved; editing one network leaves the others verifiable
  hasUnsavedNetworkIds(network: ThreeDsNetworkRow): boolean {
    let changed = true;

    if (this.gateway) {
      changed = this.idHasChanged(network.acquirerControl) || this.idHasChanged(network.merchantControl);
    }

    return changed;
  }

  // An input the user emptied holds '' where the API holds null, so both are read as unset
  protected idHasChanged(controlName: string): boolean {
    const onForm = this.form.get(controlName).value;
    const stored = this.gateway[controlName];

    return (onForm ? onForm : null) !== (stored ? stored : null);
  }

  isNetworkVerified(network: ThreeDsNetworkRow): boolean {
    const status = this.form.get(network.statusControl).value;

    return status === ThreeDsVerificationStatus.Verified && !network.editing;
  }

  isNetworkConfirmed(network: ThreeDsNetworkRow): boolean {
    return this.form.get(network.statusControl).value === ThreeDsVerificationStatus.Verified;
  }

  getNetworkChip(network: ThreeDsNetworkRow): ProductChip {
    let chip: ProductChip = { label: 'Not Verified', tone: ChipTone.Failed };

    if (this.isNetworkConfirmed(network)) {
      chip = { label: 'Verified', tone: ChipTone.Verified };
    }

    return chip;
  }

  // Reads the stored status, not isNetworkVerified(), which is false while a verified row is edited
  isNetworkAwaitingVerification(network: ThreeDsNetworkRow): boolean {
    const status = this.form.get(network.statusControl).value;
    const hasIds = !!(
      this.form.get(network.acquirerControl).value &&
      this.form.get(network.merchantControl).value
    );

    return status !== ThreeDsVerificationStatus.Verified && hasIds;
  }

  verifyNetwork(network: ThreeDsNetworkRow) {
    const acquirer = this.form.get(network.acquirerControl);
    const merchant = this.form.get(network.merchantControl);

    acquirer.markAsTouched();
    merchant.markAsTouched();

    if (acquirer.valid && merchant.valid) {
      if (this.gateway) {
        this.loading = true;
        this.gatewayService
          .verifyThreeDsNetwork(this.gateway.id, network.key)
          .pipe(takeUntil(this._destroy$))
          .subscribe(
            (data: Gateway) => {
              const status = data && data[network.statusControl];
              this.form
                .get(network.statusControl)
                .setValue(status !== undefined ? status : ThreeDsVerificationStatus.Verified, { emitEvent: false });
              network.editing = false;
              this.alertService.success(network.label + ' 3DS credentials verified.');
              this.loading = false;
            },
            (error) => {
              this.handleSubmitError(error, false, true);
              this.loading = false;
            }
          );
      } else {
        this.alertService.error('Save the gateway before verifying 3DS credentials.');
      }
    }
  }

  editNetwork(network: ThreeDsNetworkRow) {
    network.editing = true;
  }

  isEditingVerifiedNetwork(network: ThreeDsNetworkRow): boolean {
    const status = this.form.get(network.statusControl).value;

    return network.editing && status === ThreeDsVerificationStatus.Verified;
  }

  cancelNetworkEdit(network: ThreeDsNetworkRow) {
    const stored = {};

    if (this.gateway) {
      stored[network.acquirerControl] = this.gateway[network.acquirerControl];
      stored[network.merchantControl] = this.gateway[network.merchantControl];
      this.form.patchValue(stored);
    }

    network.editing = false;
  }

  hasNoNetworkSelected(): boolean {
    let missing = false;

    if (this.isThreeDsEnabled) {
      missing = !this.threeDsNetworks.some((network) => this.isBooleanFieldChecked(network.enabledControl));
    }

    return missing;
  }

  downloadPDF(content: string): void {
    const data = document.getElementById(content);
    if (data) {
      this.isPDFLoading = true;

      html2canvas(data, { scale: 2, backgroundColor: '#F8F9FB' }).then((canvas) => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        pdf.setFillColor(248, 249, 251);
        pdf.rect(0, 0, pageWidth, pageHeight, 'F');

        const imgWidth = 190;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const pdfName = content.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
        const xOffset = (pdf.internal.pageSize.getWidth() - pdf.getTextWidth(pdfName)) / 2;

        pdf.setFontSize(18).text(pdfName, xOffset, 10);
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 15, imgWidth, imgHeight);

        pdf.save(`${content}.pdf`);
        this.isPDFLoading = false;
      });
    }
  }

  setActiveTab(tab: ProfileTab) {
    this.activeTab = tab;
  }

  getAdditionalOptionLabel(option: GatewayAdditionalOptions) {
    return GatewayAdditionalOptionLabels[option];
  }

  toggleAdditionalOption(option: GatewayAdditionalOptions) {
    if (this.selected_options.indexOf(option) > -1) {
      let idx = this.selected_options.indexOf(option);
      this.selected_options.splice(idx, 1);
    } else {
      this.selected_options.push(option);
    }
  }

  copyValue(value: string) {
    copyToClipboard(value);

    this.copiedValue = value;

    setTimeout(() => {
      this.copiedValue = null;
    }, 1000);
  }

  protected getFormData(): any {
    const data = super.getFormData();
    const crmMerchants = [];
    if (this.form.value.selected_crm_merchants && this.form.value.selected_crm_merchants.length) {
      this.form.value.selected_crm_merchants.forEach((merchant) => {
        crmMerchants.push(merchant.id);
      });
    }
    data['crm_merchants'] = crmMerchants;
    data['additional_options'] = this.selected_options;

    this.threeDsNetworks.forEach((network) => {
      delete data[network.statusControl];
    });

    return data;
  }

  onSubmit() {
    this.submitted = true;
    console.log(this.form.value);
    this.updateConditionalValidators();
    this.form.markAllAsTouched();

    const isMainFormValid = this.form.valid;
    const isProcessorConfigValid = this.isProcessorConfigValid();

    if (this.hasNoNetworkSelected()) {
      this.activeTab = ProfileTab.Credentials;
      this.alertService.error('Enable at least one card network to use 3DS.');
    } else if (isMainFormValid && isProcessorConfigValid) {
      super.onSubmit();
    } else {
      this.activeTab = ProfileTab.Credentials;
    }
  }

  protected onSaveComplete(data: Gateway) {
    this.form.markAsPristine();
    this.canDeactivateService.setFormDirty(false);
    this.loading = false;
    this.threeDsNetworks.forEach((network) => {
      network.editing = false;
    });

    if (this.isNew) {
      super.onSaveComplete(data);
    } else {
      this.updateGateway(data);
    }
  }

  private isProcessorConfigValid(): boolean {
    return this.isFormGroupValid('processor_config');
  }

  protected handleSubmitError(error: HttpErrorResponse, keepAfterNavigationChange: boolean = false, showAlert: boolean = false) {
    const configGroup = this.getFormGroup('processor_config');
    let submitError = error;

    if (error && error.error && typeof error.error === 'object' && configGroup) {
      const moved = Object.assign({}, error.error);
      const configErrors = {};

      Object.keys(error.error).forEach((key) => {
        if (configGroup.contains(key)) {
          configErrors[key] = error.error[key];
          delete moved[key];
        }
      });

      if (Object.keys(configErrors).length > 0) {
        moved.processor_config = configErrors;
        submitError = new HttpErrorResponse({ error: moved, status: error.status });
      }
    }

    super.handleSubmitError(submitError, keepAfterNavigationChange, showAlert);
  }

  getKey(key: string): string {
    return key.substr(0, 6).padEnd(key.length, '*');
  }

  getStatus(): GatewayStatus {
    return getGatewayStatus(this.gateway);
  }

  getStatusLabel(): string {
    return GatewayStatusLabels[getGatewayStatus(this.gateway)];
  }

  getBankName(bankId: number) {
    let bankName: string = '--';
    if (this.banks && this.banks.length) {
      const bank = this.banks.find((bank) => bank.id === bankId);
      bankName = bank ? bank.name : '--';
    }
    return bankName;
  }

  get processorName() {
    return this.selectedProcessorType ? this.selectedProcessorType.name : '--';
  }

  getAdditionalOptionsList(optionslist: number[]) {
    let additionalOptions = '--';

    if (optionslist.length > 0) {
      additionalOptions = optionslist.map((option) => GatewayAdditionalOptionLabels[option]).join(', ') || '--';
    }

    return additionalOptions;
  }

  onBankChange(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    if (selectedValue === 'add-new-bank') {
      this.router.navigate(['/checkouts', 'bank-profiles', 'new']);
    }
  }
}
